import { createColumnHelper } from '@tanstack/react-table';

import { Ingress } from '../../types';

export const columnHelper = createColumnHelper<Ingress>();
